// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@100;200;300;400;500;600;700;800;900&family=Syne&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Syne&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
*::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

html {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-size: 62.5%;
}
html body {
  font-family: outfit, "arial";
  font-family: "Syne", sans-serif;
  background-color: white;
  font-size: 1rem;
  letter-spacing: 0.017rem;
  line-height: 1;
  overflow-x: hidden;
}

img {
  object-fit: contain;
}

a {
  display: inline-block;
  color: inherit;
  text-decoration: none;
}

hr {
  border-color: "#c1c1c1";
  margin: 0;
}

button {
  cursor: pointer;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

@media screen and (min-width: 768px) {
  .large-screen-message {
    display: block;
    display: flex;
    color: white;
    justify-content: center;
    text-align: center;
    align-items: center;
    font-size: 24px;
    padding: 20px;
    background-color: #333;
    height: 100vh;
  }
}
@media screen and (max-width: 767px) {
  .large-screen-message {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app.scss","webpack://./src/Styles/sass/_variables.scss"],"names":[],"mappings":"AAQA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;AAHJ;AAKI;EACI,UAAA;EACA,WAAA;AAHR;;AAOA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;EACA,gBAAA;AAJJ;AAMI;EACI,4BAAA;EACA,+BCUI;EDTJ,uBAAA;EACA,eCWI;EDVJ,wBAAA;EACA,cAAA;EACA,kBAAA;AAJR;;AAQA;EACI,mBAAA;AALJ;;AAQA;EACI,qBAAA;EACA,cAAA;EACA,qBAAA;AALJ;;AAQA;EACI,uBAAA;EACA,SAAA;AALJ;;AAQA;EACI,eAAA;AALJ;;AAYA;;EAEI,wBAAA;EACA,SAAA;AATJ;;AAYA;EACI,0BAAA;AATJ;;AAYA;EACI;IACI,cAAA;IACA,aAAA;IACA,YAAA;IACA,uBAAA;IACA,kBAAA;IACA,mBAAA;IACA,eAAA;IACA,aAAA;IACA,sBAAA;IACA,aAAA;EATN;AACF;AAYA;EACI;IACI,aAAA;EAVN;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700;800&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100;200;300;400;500;600;700;800;900&family=Syne&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Syne&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Outfit&display=swap');\n\n@import './Styles/sass/variables';\n@import './Styles/sass/mixins';\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n\n    &::-webkit-scrollbar {\n        width: 5px;\n        height: 5px;\n    }\n}\n\nhtml {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-size: 62.5%; // 1rem = 10px = 62.5%\n\n    body {\n        font-family: outfit, 'arial';\n        font-family: $main_font;\n        background-color: white;\n        font-size: $text_size;\n        letter-spacing: 0.017rem;\n        line-height: 1;\n        overflow-x: hidden;\n    }\n}\n\nimg {\n    object-fit: contain;\n}\n\na {\n    display: inline-block;\n    color: inherit;\n    text-decoration: none;\n}\n\nhr {\n    border-color: '#c1c1c1';\n    margin: 0;\n}\n\nbutton {\n    cursor: pointer;\n}\n\nsvg {\n    // fill: currentColor;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\ninput[type='number'] {\n    -moz-appearance: textfield;\n}\n\n@media screen and (min-width: 768px) {\n    .large-screen-message {\n        display: block;\n        display: flex;\n        color: white;\n        justify-content: center;\n        text-align: center;\n        align-items: center;\n        font-size: 24px;\n        padding: 20px;\n        background-color: #333;\n        height: 100vh;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .large-screen-message {\n        display: none;\n    }\n}\n","//Primary shades\n$primary_green: #00aa74;\n$primary_light: #e6f7ef;\n$primary_gradient: linear-gradient(109.42deg, #00aa74 0%, #16eba6 100%, #16eba6 100%);\n$primary_gradient1: linear-gradient(108deg, #00AA74 -78.7%, #1E1E1E 59.58%);\n\n//secondary shades\n$secondary_dark: #012515;\n\n//semantic\n$semantic_red: #ec6a5e;\n$semantic_orange: #dfa102;\n\n//Grey Shades\n$color_grey_400: #8c8c8c;\n$color_grey_300: #b3b3b3;\n$color_grey_200: #d9d9d9;\n$color_grey_100: #f2f2f2;\n\n//Black Shades\n$color_black_400: #000000;\n$color_black_300: #1e1e1e;\n$color_black_200: #333333;\n$color_black_100: #4c4c4c;\n\n//green shades\n$color_green_100: #e6f7ef;\n$color_green_150: #c2ead8;\n$color_green_200: #9adcbf;\n$color_green_300: #6ecfa6;\n$color_green_400: #48c493;\n$color_green_500: #09ba80;\n$color_green_600: #009766;\n$color_green_700: #00865a;\n$color_green_800: #006643;\n\n//Fontstyles\n$main_font: 'Syne', sans-serif;\n$secondary_font: 'Outfit', sans-serif;\n$tertiary_font: 'Space Grotesk', sans-serif;\n$text_size: 1rem;\n$dashboardtext: #575757;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
